import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'
import { COLORS } from '../data/enums'
import Iris from './Iris/Iris'

export default function FaceFeature({
  scaleX,
  scale,
  gradient,
  pupil,
  rotation = 0,
  spacing = 0,
  verticalOffset,
  outline,
  showEyeLiner,
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftPupilTransformOrigin = '16.22 14.24'
  const rightPupilTransformOrigin = '43.22 14.24'

  const leftEyePath =
    'M24.72,16.99s-.8-6.34-4.92-6.82c0,0-8.7-.83-10.3-.24-1.6,.59-3.78,4.19-3.78,4.19,0,0,2.17,4.78,9.16,5.5,6.98,.72,9.84-2.62,9.84-2.62Z'
  const rightEyePath =
    'M34.72,16.99s.8-6.34,4.92-6.82c0,0,8.7-.83,10.3-.24,1.6,.59,3.78,4.19,3.78,4.19,0,0-2.17,4.78-9.16,5.5-6.98,.72-9.84-2.62-9.84-2.62Z'

  return (
    <>
      <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
        {/* LEFT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${-spacing})`} transform-origin={leftPupilTransformOrigin}>
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            <path className="cls-4" d={leftEyePath} fill={COLORS.WHITE} />
            <Iris
              rotation={-rotation}
              maskPath={leftEyePath}
              gradientId={randomGradientId1}
              transformOrigin={leftPupilTransformOrigin}
            />
            <path
              className="cls-6"
              d="M16.22,16.99c1.52,0,2.75-1.23,2.75-2.75s-1.23-2.75-2.75-2.75-2.75,1.23-2.75,2.75,1.23,2.75,2.75,2.75Z"
              fill={pupil}
            />
            <path
              className="cls-5"
              d="M16.81,20.22c-.62,0-1.28-.03-1.98-.11-7.19-.74-9.47-5.58-9.56-5.79l-.11-.24,.14-.23c.23-.38,2.31-3.76,4.03-4.4,1.66-.62,9.62,.12,10.52,.21,4.47,.52,5.34,6.98,5.37,7.26l.03,.22-.14,.17c-.11,.13-2.56,2.9-8.29,2.9ZM6.29,14.14c.52,.94,2.83,4.38,8.63,4.98,5.74,.59,8.59-1.68,9.26-2.3-.19-1.11-1.19-5.77-4.45-6.15-3.44-.33-8.97-.67-10.07-.27-1.09,.4-2.69,2.65-3.38,3.74Z"
              fill={outline}
            />
            {showEyeLiner && (
              <path d="M25.24,17.15c-1.01-2.62-2.38-6.18-5.65-6.16l-3.21-.2c-2.05-.12-4.29-.35-6.29-.25-.35,0-.76,.26-1.2,.52-1.33,.88-2.5,1.98-3.73,3.02,.55-.95,1.18-1.84,1.89-2.69,.82-.89,1.49-1.81,2.8-2.18,2.29-.43,4.39-.25,6.64-.17,1.72,.2,3.37,.07,5.04,.72,2.74,1.31,3.68,4.61,3.71,7.38h0Z" />
            )}
          </g>
          <path
            className="cls-4"
            d="M18.05,13.3c.51,0,.92-.41,.92-.92s-.41-.92-.92-.92-.92,.41-.92,.92,.41,.92,.92,.92Z"
            fill={COLORS.WHITE}
          />
        </g>
        {/* RIGHT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${spacing})`} transform-origin={rightPupilTransformOrigin}>
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path className="cls-4" d={rightEyePath} fill={COLORS.WHITE} />
            <Iris
              rotation={rotation}
              maskPath={rightEyePath}
              gradientId={randomGradientId2}
              transformOrigin={rightPupilTransformOrigin}
            />
            <path
              className="cls-6"
              d="M43.22,16.99c1.52,0,2.75-1.23,2.75-2.75s-1.23-2.75-2.75-2.75-2.75,1.23-2.75,2.75,1.23,2.75,2.75,2.75Z"
              fill={pupil}
            />
            <path
              className="cls-5"
              d="M42.63,20.22c-5.74,0-8.18-2.77-8.29-2.9l-.14-.17,.03-.22c.03-.27,.9-6.74,5.36-7.26,.91-.09,8.87-.83,10.53-.21,1.72,.64,3.8,4.01,4.03,4.4l.14,.23-.11,.24c-.09,.21-2.37,5.05-9.56,5.79-.7,.07-1.36,.11-1.98,.11Zm-7.38-3.4c.67,.62,3.51,2.88,9.26,2.3,5.81-.6,8.11-4.04,8.63-4.98-.69-1.09-2.28-3.34-3.38-3.74-1.1-.41-6.63-.06-10.08,.27-3.25,.38-4.25,5.04-4.44,6.15Z"
              fill={outline}
            />
            {showEyeLiner && (
              <path d="M54.29,14.09c-1.64-1.07-3.14-2.81-4.96-3.4-1.95-.18-4.23,0-6.26,.06-1.5,.12-3.2-.08-4.63,.29-2.41,.96-3.45,3.66-4.23,6.11,.06-1.08,.26-2.17,.62-3.22,.53-1.59,1.53-3.26,3.16-4.01,2.68-.85,5.46-.83,8.25-1.02,1.11,0,2.16-.04,3.4,.17,2.35,.8,3.54,3,4.66,5.02h0Z" />
            )}
          </g>
          <path
            className="cls-4"
            d="M45.05,13.3c.51,0,.92-.41,.92-.92s-.41-.92-.92-.92-.92,.41-.92,.92,.41,.92,.92,.92Z"
            fill={COLORS.WHITE}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clippath">
          <rect className="cls-1" x="5.72" y="9.72" width="19" height="10" />
        </clipPath>
        <linearGradient
          id={randomGradientId1}
          x1="16.22"
          y1="111.31"
          x2="16.22"
          y2="121.04"
          gradientTransform="translate(0 131.24) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>

        <clipPath id="clippath-1">
          <rect className="cls-1" x="34.72" y="9.72" width="19" height="10" />
        </clipPath>
        <linearGradient
          id={randomGradientId2}
          x1="43.22"
          y1="111.31"
          x2="43.22"
          y2="121.01"
          gradientTransform="translate(0 131.24) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </>
  )
}
